import { AfterContentInit, AfterViewInit, Component, Input, OnChanges, OnInit, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { Announcement } from '@app/announcements/shared/models/announcement';
import { announcement, announcementouter, noannouncementouter } from '@app/shared/customSVGIcons/custom-svg';
import { StringConstants } from '@app/shared/string-constants';
import { chevronRightIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { KpaSidenavComponent } from '../kpa-sidenav/kpa-sidenav.component';
import { SharedService } from '@app/shared/services/shared.service';
import { PageChangeEvent } from '@progress/kendo-angular-grid';

@Component({
	selector: 'kpa-announcements-card',
	templateUrl: './announcements-card.component.html',
	styleUrl: './announcements-card.component.scss',
})
export class AnnouncementsCardComponent implements OnChanges {
	@Input() isDashboard: boolean = false;
	@Input() announcements: Announcement[] = [];
	public pagedAnnouncements: Announcement[] = [];
	public announcementIcon: SVGIcon = announcementouter;
	public noannouncementIcon: SVGIcon = noannouncementouter;
	public chevronRightIcon: SVGIcon = chevronRightIcon;
	public noAnnouncementsMessage: string = StringConstants.noAnnouncementsMessage;
	public noAnnouncementsDashboardMessage: string = StringConstants.noAnnouncementsDashboardMessage;
	public buttonCount = 5;
	public sizes = [5, 10, 20, 50];
	public pageSize: number = 5;
	public skip: number = 0;
	public total = 0;

	constructor(
		private router: Router,
		private sharedService: SharedService
	) {}

	ngOnChanges(): void {
		if (this.isDashboard) {
			this.pagedAnnouncements = this.announcements;
		} else {
			this.pageData(this.announcements);
			this.total = this.announcements.length;
		}
	}
	viewAnnouncements() {
		this.sharedService.triggerMenuItemClick({ path: 'announcements', name: 'Announcements', icon: announcement });
	}

	private pageData(announcements: Announcement[]): void {
		this.pagedAnnouncements = announcements.slice(this.skip, this.skip + this.pageSize);
	}

	onPageChange(e: PageChangeEvent): void {
		this.skip = e.skip;
		this.pageSize = e.take;
		this.pageData(this.announcements);
	}
}
